import { render, staticRenderFns } from "./EnquiryTemplateDialog.vue?vue&type=template&id=2d6a20a7&"
import script from "./EnquiryTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./EnquiryTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSpace,QBtn,QForm,QInput,QSeparator,QSelect,QToggle,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSpace,QBtn,QForm,QInput,QSeparator,QSelect,QToggle,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
